import surveysService from '../services/surveysService';

export const fetchAllSurveys = async (params) => {
  const result = await surveysService.getAllSurveys(params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Anketler alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchSurveyById = async (id) => {
  const result = await surveysService.getSurveyById(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Anket alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const createSurvey = async (payload) => {
  const result = await surveysService.createSurvey(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Anket oluşturulamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateSurvey = async (payload) => {
  const result = await surveysService.updateSurvey(payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Anket güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const deleteSurvey = async (id) => {
  const result = await surveysService.deleteSurvey(id);
  if (!result?.success) {
    const error = new Error(result?.message || 'Anket silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const reorderSurveys = async (surveyIdsInOrder) => {
  const result = await surveysService.reorderSurveys(surveyIdsInOrder);
  if (!result?.success) {
    const error = new Error(result?.message || 'Sıralama güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const publishSurvey = async (id, isActive) => {
  const result = await surveysService.publishSurvey(id, isActive);
  if (!result?.success) {
    const error = new Error(result?.message || 'Yayın durumu güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const addQuestion = async (surveyId, payload) => {
  const result = await surveysService.addQuestion(surveyId, payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Soru eklenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const updateQuestion = async (surveyId, payload) => {
  const result = await surveysService.updateQuestion(surveyId, payload);
  if (!result?.success) {
    const error = new Error(result?.message || 'Soru güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const removeQuestion = async (surveyId, questionId) => {
  const result = await surveysService.removeQuestion(surveyId, questionId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Soru silinemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const reorderQuestions = async (surveyId, questionIdsInOrder) => {
  const result = await surveysService.reorderQuestions(surveyId, questionIdsInOrder);
  if (!result?.success) {
    const error = new Error(result?.message || 'Soru sıralaması güncellenemedi');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchResponses = async (surveyId, params) => {
  const result = await surveysService.getResponses(surveyId, params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Cevaplar alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchParticipants = async (surveyId, params) => {
  const result = await surveysService.getParticipants(surveyId, params);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcılar alınamadı');
    error.details = result;
    throw error;
  }
  return { data: result.data, meta: result.metaData };
};

export const fetchResponseSummary = async (surveyId) => {
  const result = await surveysService.getResponseSummary(surveyId);
  if (!result?.success) {
    const error = new Error(result?.message || 'Özet alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export const fetchParticipantResponse = async (surveyId, personId, participantType) => {
  const result = await surveysService.getParticipantResponse(surveyId, personId, participantType);
  if (!result?.success) {
    const error = new Error(result?.message || 'Katılımcı cevapları alınamadı');
    error.details = result;
    throw error;
  }
  return result.data;
};

export default {
  fetchAllSurveys,
  fetchSurveyById,
  createSurvey,
  updateSurvey,
  deleteSurvey,
  reorderSurveys,
  publishSurvey,
  addQuestion,
  updateQuestion,
  removeQuestion,
  reorderQuestions,
  fetchResponses,
  fetchParticipants,
  fetchResponseSummary,
  fetchParticipantResponse,
};

